<template>
  <div class="subscription-package-details-wrap">
    <v-btn text @click="$router.go(-1)" style="margin-left: -16px;">
        <v-icon left>mdi-chevron-left</v-icon>
        Back
    </v-btn>
    <div class="mb-7 mt-3 d-flex flex-wrap">
        <h2 class="headline">Subscription Details</h2>
        <v-spacer></v-spacer>
        <div style="margin-left: -4px; margin-right: -4px;">
          <v-btn 
            v-if="!loading"
            @click="$root.$emit('DeleteSubscription', subscription)"
            color="error"
            class="mx-1 mb-1"
          >
            <v-icon left>mdi-delete</v-icon>
            Delete
          </v-btn>
          <template v-else>
            <v-skeleton-loader
              type="button"
              class="mx-auto mb-4"
            ></v-skeleton-loader>
          </template>
        </div>
    </div>
    <template v-if="!loading">
      <v-card>
        <v-simple-table v-if="!no_data.includes(subscription)" v-slot:default>
          <template>
            <thead>
              <tr>
                <th class="text-left">Details</th>
                <th class="text-left"></th>
              </tr>
            </thead>
            <tbody>
            <tr>
              <td>Subscription ID</td>
              <td>
                <span v-if="!no_data.includes(subscription.id)">{{ subscription.id }}</span>
                <em v-else class="grey--text">No data</em>
              </td>
            </tr>
              <tr>
                <td>Advertiser Name</td>
                <td>
                  <span v-if="!no_data.includes(subscription.name)">{{ subscription.name }}</span>
                  <em v-else class="grey--text">No data</em>
                </td>
              </tr>
              <tr>
                <td>Service Plan</td>
                <td>
                  <span v-if="!no_data.includes(subscription.subscription_package)">{{ subscription.subscription_package }}</span>
                  <em v-else class="grey--text">No data</em>
                </td>
              </tr>
              <tr>
                <td>Service Plan Contains</td>
                <td>
                  <div v-if="!no_data.includes(subscription.fields)" class="py-3">
                    <template  v-for="(i, index) in subscription.fields.filter(i => i.value != 0)">
                    <div :key="index">{{`${i.name}${i.type === 'number' ? `: ${i.value}` : ''}${index !== subscription.fields.filter(i => i.value != 0).length - 1 ? ',' : ''}`}}</div>
                    </template>
                  </div>
                  <em v-else class="grey--text">No data</em>
                </td>
              </tr>
              <tr>
                <td>Price</td>
                <td>
                  <span v-if="!no_data.includes(subscription.price)">{{ `$${subscription.price}` }}</span>
                  <em v-else class="grey--text">No data</em>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card>
    </template>
    <template v-else>
      <v-skeleton-loader
        type="paragraph"
        class="mx-auto mb-4"
      ></v-skeleton-loader>
      <v-skeleton-loader
        type="paragraph"
        class="mx-auto"
      ></v-skeleton-loader>
    </template>
    <delete-subscription @done="$router.push('/subscriptions')"></delete-subscription>
  </div>
</template>

<script>
import ApiService from "@/common/api.service"
import DeleteSubscription from "./DeleteSubscription"

export default {
  name: 'SubscriptionPackageDetails',
  components: {
    DeleteSubscription
  },
  data: () => ({
    no_data: [null, "", undefined, "null"],
    subscription: null,
    loading: false,
  }),
  mounted() {
    this.initialize()
  },
  methods: {
    initialize() {
      this.loading = true;
      ApiService.get(`/admin/subscription/${this.$route.params.id}/show`)
        .then(response => {
          this.subscription = response.data.subscription
          this.subscription.fields = JSON.parse(this.subscription.fields)
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          console.log(error.message);
        });
    },
    titleCase(str){
      return _.startCase(str.replace(/_/g, ' '))
    },
    formatDate(date) {
      return moment(date).format('MMMM Do YYYY, h:mm:ss a')
    }
  }
}
</script>
